/* This example requires Tailwind CSS v2.0+ */
import React from 'react';
import { PageTitle } from 'components/layouts/pageTitle';
import { Link } from 'react-router-dom';

export const Settings = () => {
  return (
    <>
      <PageTitle title="Settings" isTopLevel alignLeft />
      <div className="bg-white shadow overflow-hidden sm:rounded-lg mx-2 md:mx-6 lg:mx-8">
        <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
          <dl className="sm:divide-y sm:divide-gray-200">
            <div className="pb-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                <Link to="/settings/restaurants" className="font-medium text-indigo-600 hover:text-indigo-500">Restaurants</Link>
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                Manage compamy restaurants
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                <Link to="/settings/tables" className="font-medium text-indigo-600 hover:text-indigo-500">Tables</Link>
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                Define tables of each restaurant.
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                <Link
                  to="/settings/employees"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Employees
                </Link>
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                Manage your restaurant employees
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                <Link
                  to="/settings/product-categories"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Product categories
                </Link>
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                Make a list of product categories.
              </dd>
            </div>
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                <Link
                  to="/settings/variation-templates"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Variation templates
                </Link>
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                Variation templates for products.
              </dd>
            </div>
            {/* <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                <Link
                  to="/settings/drivers"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Drivers
                </Link>
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                Manage your restaurant drivers
              </dd>
            </div> */}
            {/* <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                <Link
                  to="/settings/delivery"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Delivery settings
                </Link>
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                Delivery page setup.
              </dd>
            </div> */}
          </dl>
        </div>
      </div>
    </>
  );
};
